import React from "react";

import {
  func,
  number,
  arrayOf,
  shape,
  oneOfType,
  string,
  bool,
  array,
} from "prop-types";

import TimesheetCell from "../TimesheetCell/index";

const displayRate = (rate) => {
  const priceParts = rate.split(".");
  const pence = priceParts.length === 2 ? priceParts[1].padEnd(2, "0") : "00";
  return `${priceParts[0]}.${pence}`;
};

const TimesheetRow = ({
  onEdit,
  isEditing,
  days,
  rateIdx,
  rate,
  columnErrors,
  bookedDays,
  nonAttendanceDays,
  getSalaryOption,
  rowType = "H",
  timeFrame = false,
}) =>
  timeFrame ? (
    <tr>
      <td>
        <div style={{ fontSize: "16px" }}>
          <b>{rate}</b>
        </div>
        <div style={{ fontSize: "14px" }}>24 hour time format</div>
      </td>
      {days.map((hours, dayIdx) => {
        const isValid =
          !Object.values(columnErrors[dayIdx]).includes(true) &&
          !Number.isNaN(parseFloat(hours, 10)) &&
          bookedDays[dayIdx] &&
          nonAttendanceDays[dayIdx] === null;
        return (
          <td key={`day_${rateIdx}_${dayIdx}`}>
            <TimesheetCell
              isEditing={isEditing}
              handleChange={(newValue) => onEdit(rateIdx, dayIdx, newValue)}
              hours={hours}
              bookedDay={bookedDays[dayIdx]}
              nonAttendanceCode={nonAttendanceDays[dayIdx]}
              error={false}
              cellType={rowType}
            />
          </td>
        );
      })}
    </tr>
  ) : (
    <tr>
      <td>
        <div style={{ wordBreak: "break-word" }}>{rate.displayName}</div>
        <div>
          £{displayRate(rate.payment.toString())} {getSalaryOption(rowType)}
        </div>
      </td>
      {days.map((hours, dayIdx) => {
        const isValid =
          !Object.values(columnErrors[dayIdx]).includes(true) &&
          !Number.isNaN(parseFloat(hours, 10)) &&
          bookedDays[dayIdx] &&
          nonAttendanceDays[dayIdx] === null;
        return (
          <td key={`day_${rateIdx}_${dayIdx}`}>
            <TimesheetCell
              isEditing={isEditing}
              handleChange={(newValue) => onEdit(rateIdx, dayIdx, newValue)}
              hours={hours}
              bookedDay={bookedDays[dayIdx]}
              nonAttendanceCode={nonAttendanceDays[dayIdx]}
              error={!isValid}
              cellType={rowType}
            />
          </td>
        );
      })}
    </tr>
  );

TimesheetRow.propTypes = {
  isEditing: bool,
  onEdit: func.isRequired,
  days: arrayOf(oneOfType([number, string])).isRequired,
  rateIdx: number.isRequired,
  rate: shape({ payment: number.isRequired }).isRequired,
  bookedDays: arrayOf(bool),
  nonAttendanceDays: arrayOf(string),
  columnErrors: array,
  rowType: string,
  getSalaryOption: func,
};

export default TimesheetRow;
